/**
 * Closing keywords in commit messages (commit ↔ task links, slice 3). Pure.
 *
 * GitHub's words — close, closes, closed, fix, fixes, fixed, resolve,
 * resolves, resolved — optionally followed by ":", then one key or a list
 * ("Fixes APB-1, APB-2 and APB-3", Linear accepts lists too). Case does not
 * matter. A key without a keyword before it only LINKS (commitTaskRefs.js);
 * "Refs APB-4" or "see APB-4" never closes anything.
 */

const WORDS = '(?:close[sd]?|fix(?:e[sd])?|resolve[sd]?)';
const KEY = '[A-Za-z][A-Za-z0-9]{1,4}-[1-9][0-9]{0,8}';
const SEP = '(?:\\s*,\\s*|\\s+and\\s+|\\s*&\\s*)';
const PHRASE = new RegExp(`(?<![A-Za-z0-9])${WORDS}\\s*:?\\s+((?:${KEY})(?:${SEP}${KEY})*)(?![A-Za-z0-9])`, 'gi');
const ONE_KEY = new RegExp(KEY, 'g');

/** The keys a message closes, upper case, de-duplicated, in order. */
export function closingKeysIn(text) {
  const out = [];
  for (const m of String(text || '').matchAll(PHRASE)) {
    for (const k of m[1].match(ONE_KEY) || []) {
      const key = k.toUpperCase();
      if (!out.includes(key)) out.push(key);
    }
  }
  return out;
}

/** The keys a commit (summary + body) closes. */
export function closingKeysOfCommit(commit) {
  return closingKeysIn(`${commit?.summary || commit?.message || ''}\n${commit?.body || ''}`);
}
